import { Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SharedLibModule } from '@app/core/shared-lib/shared-lib.module';
import { LoginFacade } from '../../facades/login.facade';
import { DynamicLogoComponent } from '@app/core/components/dynamic-logo/dynamic-logo.component';
import { TenantSettingsService } from '@app/core/services/tenant-settings.service';

@Component({
  selector: 'login',
  templateUrl: `login.component.html`,
  standalone: true,
  providers: [LoginFacade],
  imports: [SharedLibModule, DynamicLogoComponent],
  styles: [`
    :host {
      display: block;
    }

    .login-page {
      background-color: var(--login-bg-color, #15435e);
      color: var(--login-text-color, #ffffff);
    }

    .login-page .p-button {
      color: var(--login-bg-color, #15435e);
    }

    .login-logo-container ::ng-deep .layout-topbar-logo-content {
      flex-direction: column;
      gap: 1rem;
      cursor: default;
    }
    
    .login-logo-container ::ng-deep .layout-topbar-logo-content img {
      height: 10rem;
      width: auto;
    }
    
    .login-logo-container ::ng-deep .layout-topbar-logo-content span {
      font-size: 3.75rem;
      font-weight: bold;
    }
    
    .login-logo-container ::ng-deep .layout-topbar-logo-content:hover {
      opacity: 1;
    }
  `]
})
export class LoginComponent implements OnInit {
  private loginFacade = inject(LoginFacade);
  private tenantSettingsService = inject(TenantSettingsService);

  hasError = false;
  loginForm = new FormGroup({
    email: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
  });

  ngOnInit(): void {
    this.tenantSettingsService.loadTenantImages().subscribe();
  }

  login() {
    this.loginFacade.login();
  }
}
